import { createContext, useContext, useMemo } from 'react';
import { BoardTableQueryResult } from '../../shared/useBoardTableQuery';
import { useBoardContext } from '../BoardContext';

type BoardTableContext = {
  table: BoardTableQueryResult;
};

const context = createContext<BoardTableContext>(null as any);

export const useBoardTableContext = () => useContext(context);

type BoardContextProps = {
  children: React.ReactNode;
  table: BoardTableQueryResult;
};

export const BoardTableContextProvider = ({
  children,
  table,
}: BoardContextProps) => {
  const { board } = useBoardContext();

  const value = useMemo<BoardTableContext>(
    () => ({
      table,
    }),
    [table],
  );

  return (
    <>
      <context.Provider value={value}>{children}</context.Provider>
    </>
  );
};
